import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { FsPanoramaCamera } from './panorama-camera';

export class FsCameraPlacement extends SnModel {
  @Expose()
  public cameras: FsPanoramaCamera[];

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
